/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&setup=true&name=corrugationButton&lang=js"
export * from "./index.vue?vue&type=script&setup=true&name=corrugationButton&lang=js"

import "./index.vue?vue&type=style&index=0&id=16f8548e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16f8548e"]])

export default __exports__